import { SDate } from '@summit/core';
import { DaysOfWeek, SummitFormattedText } from '@summit/models';
import { Dayjs } from 'dayjs';
import { EboNameObject } from '../../base-classes/ebo-name-object';
import { EboObjectTO } from '../../base-classes/ebo-object-to';
import { Employee } from '../../employee/employee';
import { EmployeePayrollGroup } from '../../employee/employee-payroll-group';
import { EmployeeStatus } from '../../employee/status/employee-status.enum';
import { Company } from '../../organization/company/company';
import { Incentive } from '../../payroll/incentive/incentive';
import {
  GetApplicableEmployee,
  GetDefaultSortString,
  IWageRuleOrdered
} from '../../payroll/shared/i-wage-rule-ordered';
import { WageEmployeeFilterType } from '../../shared/payroll/wage-employee-filter-type.enum';

export class DivisionIncentive extends EboObjectTO implements IWageRuleOrdered {
  //Ignore
  ruleSetId: string;
  ruleSet: EboNameObject;
  days: DaysOfWeek = DaysOfWeek.AllDays;

  //start here
  ruleOrder: number;
  createdDate: Dayjs;
  employeeFilterType: WageEmployeeFilterType;
  employeeId: string;
  employee: Employee;
  companyId: string;
  company: Company;
  payrollGroupId: string;
  payrollGroup: EmployeePayrollGroup;
  employeeStatus: EmployeeStatus;
  invertFilter: boolean;
  startTime: Dayjs;
  endTime: Dayjs;

  incentiveID: string;
  incentive: Incentive;

  constructor(jsonData: Partial<DivisionIncentive>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.startTime) this.startTime = SDate.newUtc(jsonData.startTime);
      if (jsonData.endTime) this.endTime = SDate.newUtc(jsonData.endTime);
      if (jsonData.createdDate) this.createdDate = SDate.newUtc(jsonData.createdDate);
      if (jsonData.employee) this.employee = new Employee(jsonData.employee);
      if (jsonData.company) this.company = new Company(jsonData.company);
      if (jsonData.payrollGroup) this.payrollGroup = new EmployeePayrollGroup(jsonData.payrollGroup);
      if (jsonData.incentive) this.incentive = new Incentive(jsonData.incentive);
    }
    this.employeeFilterType ??= WageEmployeeFilterType.All;
  }

  get defaultSort() {
    return GetDefaultSortString(this);
  }

  get applicableEmployee(): SummitFormattedText {
    return GetApplicableEmployee(this);
  }

  isActive(): boolean {
    const now = SDate.getNormalized();
    return this.startTime.isSameOrBefore(now) && (!this.endTime || this.endTime.isSameOrAfter(now));
  }
}
